import { render, staticRenderFns } from "./SmsConfirmationWithCf.vue?vue&type=template&id=f4ec21ec&scoped=true"
import script from "./SmsConfirmationWithCf.vue?vue&type=script&lang=js"
export * from "./SmsConfirmationWithCf.vue?vue&type=script&lang=js"
import style0 from "./SmsConfirmationWithCf.vue?vue&type=style&index=0&id=f4ec21ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ec21ec",
  null
  
)

export default component.exports